// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2x8Va","title":"BackImages_title__FEC3Z","images":"BackImages_images__27V-r"};